import { Image, Text, View } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';

export interface ILegend {
    name: string;
    logo: string;
    width?: number;
    height?: number;
    value?: number | string;
}

export interface ILegendProps {
    data?: (ILegend | undefined)[];
}

export default (props: ILegendProps) => {
    const { t } = useTranslation();

    return (
        <View style={{ position: 'absolute', flexDirection: 'column', padding: '5 5' }}>
            {props.data?.map(
                x =>
                    x !== undefined && (
                        <View style={{ flexDirection: 'row', marginBottom: 1, alignItems: 'center' }}>
                            <View style={{ width: 30, alignItems: 'center' }}>
                                <Image style={{ width: x.width ? x.width : 25, height: x.height ? x.height : 10, marginRight: 3 }} src={x.logo}></Image>
                            </View>
                            <Text style={{ fontSize: 7, color: 'black' }}> {t(x.name, { value: x.value })}</Text>
                        </View>
                    ),
            )}
        </View>
    );
};
